import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { RolePermissionSerializer } from './role-permission.serializer'
import { RolePermission } from './role-permission'

@Injectable()
export class RolePermissionService extends ResourceService<RolePermission> {
  constructor(
    http: HttpClient,
    rolePermissionSerializer: RolePermissionSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/role-permissions`,
      rolePermissionSerializer
    )
  }
}
